import { useGetApprovalItemStatsQuery } from 'features/comments/approvalApi';

/**
 * @param {string} uri
 * @param {boolean} skip
 *
 * @returns {import('models/approval.models').ApprovalItemStats | undefined}
 */
export function useGetApprovalItemStats(uri, skip = false) {
    const results = useGetApprovalItemStatsQuery(uri, {
        skip: uri === undefined || skip === true,
    });

    return results?.currentData;
}
